import AllFoodOrderContainer from './AllFoodOrderContainer'

const AllFoodOrder = () => {
  return (
    <div className='page-body'>
      <AllFoodOrderContainer />
    </div>
  )
}

export default AllFoodOrder